import { doGoogleOauth } from 'actions/auth'
import { V5_EMAIL_PAGE, V5_COMPANY_PAGE } from '../pages'

export function doEmailSignup() {
  return dispatch => {
    dispatch({ type: V5_EMAIL_PAGE })
    return Promise.resolve()
  }
}

export function doGoogleSignup() {
  return dispatch => {
    return dispatch(
      doGoogleOauth(
        V5_COMPANY_PAGE,
        { signup: true },
        { rethrowErrorOnClosedPopup: true }
      )
    )
  }
}
